// Time management for consistent animations
export class Time {
    private static instance: Time;

    public current: number = 0;
    public elapsed: number = 0;
    public delta: number = 16;
    private previousTime: number = 0;
    private callbacks: Set<(delta: number, elapsed: number) => void> = new Set();

    private constructor() {
        this.previousTime = performance.now();
    }

    static getInstance(): Time {
        if (!Time.instance) {
            Time.instance = new Time();
        }
        return Time.instance;
    }

    update(): void {
        this.current = performance.now();
        this.delta = this.current - this.previousTime;
        this.previousTime = this.current;
        this.elapsed += this.delta;

        // Clamp delta to prevent huge jumps
        this.delta = Math.min(this.delta, 100);

        // Notify all subscribers
        this.callbacks.forEach(cb => cb(this.delta, this.elapsed));
    }

    subscribe(callback: (delta: number, elapsed: number) => void): void {
        this.callbacks.add(callback);
    }

    unsubscribe(callback: (delta: number, elapsed: number) => void): void {
        this.callbacks.delete(callback);
    }
}
